import { render } from "./LazyLoadSelectOld.vue?vue&type=template&id=9c9f5f5c"
import script from "./LazyLoadSelectOld.vue?vue&type=script&lang=js"
export * from "./LazyLoadSelectOld.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__